import React, { useEffect, useState } from 'react';
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  Loader
} from '../../../components/commons';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import { getAllFinacUsersAction, resetFinacUsersList, resetSession } from '../../../redux/auth';
import { createUserAction, getAllMenuListAction, getAllUserGroupsAction, resetUserManagementError, resetUserManagementSuccess, updateMenuListAction } from '../../../redux/userManagement';
import { MenuType, UserGrouptype } from '../../../redux/userManagement/userManagementTypes';
import {  AddEditMenuModal} from '../../../components/UserManagement';
import { toast, Toaster } from 'react-hot-toast';
import { Button } from 'react-bootstrap';
import { CreateMenuPayloadType,GetAllUserGroupPayloadType } from '../../../commonTypes/userManagementTypes';
import UserManagementTable from '../../../components/UserManagement/UserManagementTable/UserManagementTable';
import { USER_MANAGEMENT_TABLE_HEADERS } from '../../../constant/tableHeadersConstants/userManagementConstants/userManagementTableConst';
import { UserManagementImage } from '../../../assets/images';
import { SELECT_CATEGORY_OPTION } from '../../../components/UserManagement/UserManagementTable/AddEditMenuModal';
import { useMenuCheck } from '../../../customHooks/useMenuCheck';
import { GetAllFinacUserPayloadType} from '../../../commonTypes/authTypes';


type AppProps = {
  token: string | null;
  finacUsersList: any;
  success: number | null;
  fetching: boolean;
  error: string | null;
  statusCode: number | null;
  history?: any;
  allMenuList:MenuType[]|[];
  userGroupList: [] | UserGrouptype[];
  createMenuMessage:any;
  dispatchResetSession: () => void;
  dispatchResetUserManagementError: () => void;
  dispatchResetUserManagementSuccess: () => void;
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) => void,
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void | undefined;
  dispatchAllMenuList:(token:string) => void | undefined;
  dispatchMenuCreateAction:(data:any)=>void;
  dispatchUpdateMenuAction:(data:any)=>void
  dispatchResetFinacUsersList:()=>void
}

const AddEditMenuList = ({
  token,
  success,
  allMenuList,
  statusCode,
  error,
  fetching,
  createMenuMessage,
  dispatchResetSession,
  dispatchGetAllUserGroupsAction,
  dispatchResetUserManagementError,
  dispatchResetUserManagementSuccess,
  dispatchGetAllFinacUsersAction,
  dispatchAllMenuList,
  dispatchMenuCreateAction,
  dispatchUpdateMenuAction,
  dispatchResetFinacUsersList
}: AppProps) => {
  const [successMessage, setSuccessMessage] = useState<string>('');
    const [showAddMenuModal, setShowAddMenuModal] =
    useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [editMenuDetailsData, setEditMenuDetailsData] = useState<any>({});

    //========== User Management ==========//
	  const [isAddMenuListPresent, setIsAddMenuListPresent] = useMenuCheck();
	  const [isEditMenuListPresent, setIsEditMenuListPresent] = useMenuCheck();
	  //====================//

  useEffect(() => {
    dispatchResetUserManagementError();
    dispatchResetUserManagementSuccess();
    dispatchResetFinacUsersList();
    setIsAddMenuListPresent("Add Menu List","menu")
    setIsEditMenuListPresent("Edit Menu List","menu")
    if (token) {
      dispatchGetAllUserGroupsAction({token})
      const finalData={
        token,
        user_type:'all',
        status:1
      }
      dispatchGetAllFinacUsersAction(finalData)
      dispatchAllMenuList(token)
    }
  }, []);

  const handleSendMenuDetailsToModal = (data: any) => {
    setIsEdit(true);
    let findingLabel=SELECT_CATEGORY_OPTION.filter((e)=>{return e.value===data.category})
    data={...data,category:findingLabel[0]}
    setEditMenuDetailsData(data);
    setShowAddMenuModal(true);
  };


  const handleEditMenuDetails = (data: any) => {
    let finalData = {
      menu_id: editMenuDetailsData.menu_id,
      menu_name: data.menu_name,
      front_end_route: data.front_end_route,
      api_url: data.api_url,
      is_client_url: data.is_client_url,
      parent_id: data.parent_id,
      category: data.category,
      action: data.action,
      coming_soon: data.coming_soon,
      finac_key: data.finac_key,
      active_icon: data.active_icon,
      icon: data.icon,
      is_new: data.is_new,
      description:data.description,
      params_type:data.params_type,
      token
    };

    if (token) {
      dispatchUpdateMenuAction(finalData);
      dispatchAllMenuList(token)
      setIsEdit(false);
    }
    setShowAddMenuModal(false);
    setSuccessMessage("Menu Updated Successfully!");
  };
  
  const handleResetEditData = () => {
    setIsEdit(false);
    setEditMenuDetailsData({});
  };

  const toggleAddAccountModal = () => {
    setShowAddMenuModal(!showAddMenuModal);
  };

  const handleSubmit=(data:CreateMenuPayloadType)=>{
    
    dispatchMenuCreateAction(data)
    if(token){
      dispatchAllMenuList(token)
    }
    setSuccessMessage(`Menu Created Successfully!`)
  }


  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        )
      } else if ((!!error && statusCode !== 401)) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserManagementError();
            }}
          />
        )
      }
    }
    else if (success === 1) {
      dispatchResetUserManagementSuccess()
      toast.success(successMessage, {
        duration: 2000
      });
    }

    return false;
  }


  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader
            title='Add/Edit Menu'
          />
        </div>
        <div className="col-md-6">
          <div className="d-flex flex-row justify-content-end">
                {isAddMenuListPresent && <Button
                  className="btn btn-primary"
                  onClick={()=>setShowAddMenuModal(true)}
                >
                  + Add Menu
                </Button>}
          </div>
        </div>
      </div>

      <div className="col-md-12 mt-4">
        <div className="content-area">

          {fetching ? null : allMenuList?.length ? (
            <UserManagementTable
              data={allMenuList}
              fetching={fetching}
              handleEditMenuDetails={handleSendMenuDetailsToModal}
              headers={USER_MANAGEMENT_TABLE_HEADERS}
              isEditMenuListPresent={isEditMenuListPresent}
            />
          ) : (
            <EmptyListPage
              title="No Menu Found!"
              text="Add Menu and manage the list here"
              buttonTitle="+ Add Menu"
              showAddButton
              onButtonClick={()=>setShowAddMenuModal(true)}
              image={UserManagementImage}
              imageWidth="30%"
            />
          )}
        </div>
      </div>

   
      {handleErrorModal()}
      {showAddMenuModal && (
        <AddEditMenuModal
        setShowAddMenuModal={setShowAddMenuModal}
        handleSubmit={handleSubmit}
        success={success}
        error={error}
        token={token}
        allMenuList={allMenuList}
        isEdit={isEdit}
        handleResetEditData={handleResetEditData}
        toggleAddAccountModal={toggleAddAccountModal}
        editMenuDetailsData={editMenuDetailsData}
        handleEditMenuDetails={handleEditMenuDetails}
        />
      )}
      {fetching && <Loader />}
      <Toaster />
    </>
  )
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  finacUsersList: state.auth.finacUsersList,
  fetching: state.userManagement.fetching,
  success: state.userManagement.success,
  statusCode: state.userManagement.statusCode,
  error: state.userManagement.error,
  userGroupList: state.userManagement.userGroupList,
  createMenuMessage:state.userManagement.createMenuMessage,
  allMenuList:state.userManagement.menuList
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetUserManagementError: () => dispatch(resetUserManagementError()),
  dispatchResetUserManagementSuccess: () => dispatch(resetUserManagementSuccess()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchGetAllUserGroupsAction: (data: GetAllUserGroupPayloadType) => dispatch(getAllUserGroupsAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => dispatch(getAllFinacUsersAction(data)),
  dispatchMenuCreateAction:(data:CreateMenuPayloadType)=> dispatch(createUserAction(data)),
  dispatchAllMenuList:(token:string)=>dispatch(getAllMenuListAction(token)),
  dispatchUpdateMenuAction:(data:CreateMenuPayloadType)=>dispatch(updateMenuListAction(data))
})

export default connect(mapStateTopProps, mapDispatchToProps)(AddEditMenuList);